import React, { PropTypes } from "react";

const UpcomingWebinars = ({
  webinars,
  nextPage,
  pagination,
  count,
  noTitle,
}) => (
  <div>
    <div className={`container_upcoming row ${noTitle ? "noTitle" : ""}`}>
      <div className={`section_upcoming_block ${noTitle ? "noTitle" : ""}`}>
        {typeof webinars === "function" ? webinars(noTitle) : webinars}
      </div>
    </div>
    {!webinars.length && (
      <p className="group-no-webinars">There are no upcoming meetings</p>
    )}
  </div>
);

UpcomingWebinars.propTypes = {
  webinar: PropTypes.obj,
};

export default UpcomingWebinars;



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/Webinars/Upcoming/UpcomingWebinars.js